import React,{useState, useEffect} from "react";
import { parse,format } from "date-fns"; 
import { useHistory,useParams } from "react-router-dom";
import { login_Id } from "../store/config/dadosuser";
import { get,post } from "../store/config/register";
import { toast } from "react-toastify";
import Main from "../components/template/Main";
import { isEthereumAddress } from "validator";

const initialState ={
    agenda: {
      id: 0,
      responsavel: '',
      descricao: ''

    }
  }

  
  const headerProps = {
    icon: "calendar",
    title: "Agenda",
  }


export default function ReservaAgenda(){

    const [horarios, setHorarios]=useState([]);
    const [agendamentos,setAgendamentos]= useState([]);
    const [maiorHoje,setMaiorHoje]= useState(false);
    const [usuario,setUsuario] = useState({})
    const [horario, setHorario] = useState(false );
    const [espaco,setEspaco] = useState({})
    const [horarioPadrao,setHorarioPadrao]= useState([]);

    const history = useHistory();

    let unidade = false;

    const {id,data}=useParams();
    let dataAgenda = parse(data,'dd-MM-yyyy',new Date());
    let diaSemana = dataAgenda.getDay()+1;


    useEffect(() => {
       buscaAgenda();
       buscaHorarioPadrao();
       Horarios(diaSemana);
       VerificaUsuario();
       buscaEspaco();
       },[])



     async function buscaAgenda() {
        const agenda = await get(`/EspacoAgenda/v1/Dia?espaco_id=${id}&inicio=${format(dataAgenda,'yyyy-MM-dd')}`);
        if(agenda !== undefined){
            setAgendamentos(agenda)
         }
       }

    async function buscaHorarioPadrao() {
        const hors = await get('/EspacoPeriodoPadrao/v1/Espaco/'+ id);
        if(hors !== undefined){
         setHorarioPadrao(hors)
       }
       }

       async function buscaEspaco() {
        const esp = await get('/Espaco/v1/'+ id);
         if(esp !== undefined){
           setEspaco(esp)
          
         }
       }

       async function VerificaUsuario(){

        if(login_Id > 0){
          const  result = await  get(`/Login/v1/${login_Id}`);
            setUsuario(result)
       }
       
      }

       async function Horarios(diaSemana){
        setHorario(false);
        const hors= await get(`/EspacoPeriodoHora/v1/Horarios?espaco_id=${id}&dia_semana=${diaSemana}`)

        if(hors.length > 0){
               setHorario(true);
            //    hors.unshift({id: 0, hora_Inicio: '', hora_Fim: ''})
               setHorarios(hors)
           }
       }



  
        async function ExisteAgendamento(inicio){           

           const res = await get('/EspacoAgenda/v1/Existe?espaco_id='+id+'&inicio='+ format(dataAgenda,"yyyy-MM-dd ")+inicio);
           return res.existe;
        }

       async function SelecionarHorario( item){
            let existe =await ExisteAgendamento(item.hora_Inicio);
            if(existe === false){
                history.push(`/ReservaEspaco/AgendaDia/${id}/${data}/${item.hora_Inicio}`);
            }else {
                await toast.warning('Já existe um agendamento para este horário');
            }
            
        }
    
    
    function renderForm(){


        return (
            <div>

                <div>

                    <label>Dia:</label>
                    <label className="dia" name="responsavel" >{format(dataAgenda,'dd/MM/yyyy') } </label> 

                    <div>
                        <label>Responsável:</label>
                        <input className="form-control agendaResp" name="responsavel" value={usuario.bloco+' - '+usuario.unidade+ ' - '+ usuario.nome} />
                    </div>
                    <hr/>
                    {horario === true  
                    && 
                    (
                        <div className="lista">
                            {horarios.length > 0 && horarios.map((item)=>{

                                   let agenda =  agendamentos.filter(f => f.hora_Inicio === item.hora_Inicio);                     
                                   let unidadeAgenda = false;
                                   if(agenda.length > 0) {
                                     unidadeAgenda = agenda[0].unidade_Id === usuario.unidade_Id ? true:false;
                                     if(unidade === false){
                                         unidade =agenda[0].unidade_Id === usuario.unidade_Id? true: false;
                                    }
                                   }

                                return(
                                    <div className="lista">
                                    <button className= {agenda.length <= 0 ?  "btn btn-success":  unidade === true?"btn btn-warning": "btn btn-secondary"} onClick={async()=> {
              
                                      if(agenda.length === 0 && unidade === false){
                                        await SelecionarHorario(item);
                                      }else {
                                        if(unidade === false){
                                            await toast.warning('Já existe um agendamento para este horário');
                                        }else {
                                            if(unidadeAgenda === false){
                                                await toast.warning('A sua Unidade  já possui agendamento, para está data');
                                            }else { 
                                                await toast.warning('Abrir agendamento');
                                            }
                                           
                                        }
                                       
                                      }

                                        }
                                        }>{item.hora_Inicio}</button>
                                    </div>
                                )

                            })} 
                          
                            
                        </div>
                    )
                    }

                    {horario === false && (
                      <div className="lista">
                        {horarios.length === 0 &&

                          horarioPadrao.map((item)=>{
                            if(item.dia_Semana === diaSemana){
                              let agenda =  agendamentos.filter(f => f.hora_Inicio === item.hora_Inicio);                     
                              let unidadeAgenda = false;
                              if(agenda.length > 0) {
                                unidadeAgenda = agenda[0].unidade_Id === usuario.unidade_Id ? true:false;
                                if(unidade === false){
                                    unidade = agenda[0].unidade_Id === usuario.unidade_Id? true: false;
                                }
                              }

                              return (
                                <div>
                                    <div className="lista">
                                    <button className= {agenda.length <= 0 ?  "btn btn-success":  unidade === true?"btn btn-warning": "btn btn-secondary"} onClick={async()=> {

                                      if(agenda.length === 0 && unidade === false){
                                        await SelecionarHorario(item);
                                      }else {
                                        if(unidade === false){
                                            await toast.warning('Já existe um agendamento para este horário');
                                        }else {
                                            if(unidadeAgenda === false){
                                                await toast.warning('A sua Unidade  já possui agendamento, para está data');
                                            }else { 
                                                await toast.warning('Abrir agendamento');
                                            }
                                          
                                        }
                                      
                                      }

                                        }
                                        }>{item.hora_Inicio}</button>
                                    </div>
                                </div>
                              )
                            }

                          
                          })
                          }
                      </div>
                    )}                   
                </div>    

            </div> 
        )
    }
    return(
        <Main {...headerProps}>
            {renderForm()}
        </Main>
    )
}